var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19, _path20, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoldOut = function SvgSoldOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149.734,
    height: 136.822
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.862,
    cy: 78.671,
    r: 58.151,
    fill: "#A3CBE8",
    opacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C072",
    d: "m64.693 133.983 9.462-37.847a3.68 3.68 0 0 1 3.579-2.794h25.04a3.685 3.685 0 0 1 3.58 2.795l9.461 37.847h3.804l-9.685-38.742a7.4 7.4 0 0 0-.807-1.957 1.84 1.84 0 0 0 1.373-1.406l7.374-34.962a3.71 3.71 0 0 1 3.61-2.928h3.352a1.845 1.845 0 1 0 0-3.69h-3.352c-3.467 0-6.504 2.463-7.22 5.856l-7.065 33.499H77.734a7.366 7.366 0 0 0-7.158 5.589l-9.686 38.742h3.803z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E0C072",
    d: "M109.246 101.95H71.261a1.845 1.845 0 1 1 0-3.69h37.985a1.845 1.845 0 1 1 0 3.69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF8F",
    d: "m95.213 24.136 12.894-.704 1.021 18.714-12.894.704z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF8F",
    d: "M96.417 28.296s9.927 6.623 14.006.326c0 0 6.174-8.836 7.054-10.521 1.461-2.795 1.831-7.747-6.294-11.787 0 0-9.001-4.844-14.766 6.763 0 0-6.764 11.222 0 15.219"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#983D24",
    d: "M103.335.62c13.489-2.998 16.564 5.616 17.371 10.113s3.805 6.572 3.805 6.572c-12.567 3.805-17.578-8.916-17.578-8.916-2.273 4.136-4.477 6.922-6.422 8.805-.468-.994-1.324-1.602-2.132-1.412-.988.233-1.52 1.56-1.189 2.965a3.6 3.6 0 0 0 .321.846c-2.435 1.534-4.003 1.518-4.003 1.518C92.482 6.93 103.335.62 103.335.62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#E35C43",
    d: "M95.706 33.143 73.985 77.187l22.305 10.37 16.28-51.806-3.976-3.4s-2.02 6.052-8.425 6.527c-4.133.308-4.463-5.735-4.463-5.735"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE2E4",
    d: "M95.706 33.143 76.328 78.277l-6.912-3.171 12.513-34.243s1.072-6.033 8.324-6.802z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB5E50",
    d: "M43.509 126.719v7.264H17.337s.807-3.228 6.456-4.497c5.65-1.268 11.308-3.961 11.308-3.961z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#27719D",
    d: "m77.815 74.814-26.466 1.06s-7.195 1.582-9.339 9.915l-8.993 39.284 11.299 2.453 12.452-37.874h39.523s3.66-10.667-5.394-13.896c0 0-6.686-.942-13.082-.942"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE2E4",
    d: "M108.595 32.352 85.207 89.709l16.965-.058s6.176-5.524 9.978-23.486l7.492-28.877s0-1.537-2.306-2.46c-2.306-.921-8.741-2.476-8.741-2.476"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#DFE2E4",
    d: "m118.968 35.89 17.562 6.04-5.715 7.112-12.968-4.836z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EEF2",
    d: "m95.706 33.143-2.534.426-7.427 10.561 1.345 1.883-3.651 3.42.068 12.124zm12.889-.791L95.503 64.459l9.919-10.837-1.729-6.272h4.15l2.455-14.574z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF8F",
    d: "m115.966 49.436-9.78 5.23 3.09 4.817 9.288-3.004z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EEF2",
    d: "m118.564 56.479 19-6.195s3.639-2.488 1.346-6.836c0 0-1.814-3.614-6.74-1.861l-16.791 7.282z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF8F",
    d: "m21.948 82.853-3.804 2.191 5.534 8.993 3.805-2.643z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#3B7FB8",
    d: "M67.687 75.22S59.42 59.955 50.888 64.267L19.873 83.484l7.379 12.221L54.696 75.74z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#CB5E50",
    d: "m24.982 93.034-4.533 5.675L0 82.374s2.646-2.018 7.851.517 10.404 1.967 10.404 1.967z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A4B4B",
    d: "M137.244 103.045h-14.066a4.617 4.617 0 0 1-4.612-4.612V63.845a4.617 4.617 0 0 1 4.612-4.612h14.066a4.617 4.617 0 0 1 4.612 4.612v34.589a4.617 4.617 0 0 1-4.612 4.611m-14.066-41.967a2.77 2.77 0 0 0-2.767 2.767v34.589a2.77 2.77 0 0 0 2.767 2.767h14.066a2.77 2.77 0 0 0 2.767-2.767V63.845a2.77 2.77 0 0 0-2.767-2.767z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EEF2",
    d: "M122.255 58.234h16.141v3.975h-16.141z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#92928E",
    d: "M142.858 128.679h-25.295a6.876 6.876 0 0 1-6.876-6.876V83.214a6.876 6.876 0 0 1 6.876-6.876h25.295a6.876 6.876 0 0 1 6.876 6.876v38.589a6.875 6.875 0 0 1-6.876 6.876"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5A4B4B"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.99,
    cy: 131.331,
    r: 2.652
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 143.431,
    cy: 131.331,
    r: 2.652
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBF8F",
    d: "M106.229 54.648s-6.48 7.309-5.953 10.022 2.939 5.802 6.707 3.316c0 0 2.035-1.733.904-2.562 0 0 2.411-2.11 1.582-6.254"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#5A4B4B",
    d: "m105.676 55.489 3.873 4.42.589-.674-2.82-5.346c0 .001-1.768.548-1.642 1.6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.778,
    cy: 55.161,
    fill: "#5A4B4B",
    rx: 1.169,
    ry: 1.457,
    transform: "rotate(45.001 106.779 55.16)"
  })));
};
export default SvgSoldOut;